import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
    providedIn: 'root'
})
export class LoaderService {
    private loadingSubject = new BehaviorSubject<boolean>(false);
    loading$ = this.loadingSubject.asObservable();

    show() {
        Promise.resolve().then(() => {
            this.loadingSubject.next(true);
        });
    }

    hide() {
        Promise.resolve().then(() => {
            this.loadingSubject.next(false);
        });
    }
}
